import { container } from "tsyringe";
import { KulionerApiRepository } from '../../repositories/api/KulionerApiRepository';
import ApiService from '../../services/ApiService';
import { KulionerMapper } from '@/data/persistences/mappers/KulionerMapper';
import { KulionerEndpoint } from '../../endpoints/KulionerEndpoint';
import { KulionerPrensenter } from '@/app/ui/presenters/KulionerPresenter';

export class KulionerComponent {
  public static init() {
    container.register<KulionerApiRepository>(KulionerApiRepository, {
      useFactory: d => {
        return new KulionerApiRepository(
          d.resolve(ApiService),
          d.resolve(KulionerMapper),
          d.resolve(KulionerEndpoint)
        )
      }
    });
    container.register<KulionerMapper>(KulionerMapper, {
      useClass: KulionerMapper
    });
    container.register<KulionerPrensenter>(KulionerPrensenter, {
      useFactory: d => {
        return new KulionerPrensenter(d.resolve(KulionerApiRepository))
      }
    })
  }
}

